import { motion } from "framer-motion";
import { MANIFESTO } from "@/data/content";

export default function Manifesto() {
  return (
    <section
      id="manifesto"
      className="relative border-t border-white/10 bg-[#0c0c0c] py-24 md:py-40"
      data-testid="manifesto-section"
    >
      <div className="mx-auto max-w-[1600px] px-5 md:px-10">
        <div className="mb-16 flex items-end justify-between">
          <span className="font-mono text-xs uppercase tracking-[0.3em] text-[#0033ff]">
            02 — Ethos
          </span>
          <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#52525b]">
            [ 03 chapters ]
          </span>
        </div>

        <div>
          {MANIFESTO.map((m, i) => (
            <motion.div
              key={m.no}
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true, margin: "-100px" }}
              transition={{ duration: 0.8, delay: i * 0.05 }}
              className="group grid grid-cols-1 items-start gap-6 border-t border-white/10 py-10 transition-colors duration-500 hover:bg-white/[0.02] md:grid-cols-12 md:py-14"
              data-testid={`manifesto-item-${m.no}`}
            >
              <div className="md:col-span-2">
                <span className="font-display text-5xl font-extrabold text-[#1c1c1e] transition-colors duration-500 group-hover:text-[#0033ff] md:text-7xl">
                  {m.no}
                </span>
              </div>
              <div className="md:col-span-3">
                <h3 className="font-display text-2xl font-extrabold uppercase tracking-tight text-[#f4f4f5] md:text-4xl">
                  {m.title}
                </h3>
              </div>
              <div className="md:col-span-7">
                <p className="max-w-2xl font-mono text-sm leading-relaxed text-[#a1a1aa] md:text-base">
                  {m.body}
                </p>
              </div>
            </motion.div>
          ))}
          <div className="border-t border-white/10" />
        </div>
      </div>
    </section>
  );
}
